import React from 'react';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import { useAppContext } from '@prisjakt/ui-app-context';
import { HorizontalScroll } from 'src/components/horizontal-scroll';
import { H3Text } from '@prisjakt/ui/text/variants';
import Button from '@prisjakt/ui-button';
import { Product } from '../../../types';
import { useViewportContext } from '../../../components/viewport/context';
import { OffersGrid } from '../../product-collection/components/offers-grid';
import { ProductCardWrapper } from './product-card-wrapper';
import * as S from './styles';

type Props = {
  title: string;
  id: string;
  link?: string;
  products: Product[];
  onClick?: (p: Product) => void;
};
export const ProductSection = ({
  id,
  title,
  link,
  products,
  onClick,
}: Props) => {
  const { isMobile } = useViewportContext();
  const { t } = useAppContext();
  return (
    <S.ProductSection key={id}>
      <S.HeadlineContainer>
        <H3Text className="category-title">{title}</H3Text>
        {link && (
          <Button href={link} color="link">
            {t('category', 'subcategories.show-all')}
            <ChevronRight />
          </Button>
        )}
      </S.HeadlineContainer>
      {isMobile ? (
        <HorizontalScroll
          loadingHeight={140}
          showArrows={false}
          itemHint
          itemWidth={110}
        >
          {products.slice(0, 8).map(p => (
            <S.ProductPadding key={p.id}>
              <ProductCardWrapper product={p} onClick={onClick} />
            </S.ProductPadding>
          ))}
        </HorizontalScroll>
      ) : (
        <OffersGrid
          offers={products.slice(0, 8).map(p => (
            <ProductCardWrapper key={p.id} product={p} onClick={onClick} />
          ))}
        />
      )}
    </S.ProductSection>
  );
};
